module.exports = __webpack_public_path__ + "static/media/importICloud2.abacf6b5.png";